<script>
  import { querystring, push } from "svelte-spa-router"
  import Navbar from "../../../../../Shared/Navbar/index.svelte"
  import Footer from "../../../../../Shared/footer.svelte"
  import ApplicationState, { getupdatedAppStateValue } from "../../../../../Stores/applicationStates"
  import notify from "../../../../../Script/notify"
  import AuthInput from "../../../../../Shared/authInput.svelte"
  import { queryStringToJSON } from "../../../../../Script/queryString"
  import Header from "../../Components/header.svelte"
  import LoadingScreen from "../../../SinglePublish/Components/loadingScreen.svelte"
  import BadgePublish, { updateBadgePublish } from "../../Stores/badge"
  import { fetchSignature, publishDocument } from "../../Script/api"

  /**
   * @type {Boolean} - whether to disable next button or not
   */
  let showLoading = false

  /**
   * @type {Object} - object get from window location
   */
  let query = queryStringToJSON($querystring)

  /**
   * @type {String} - massage for loading screen
   */
  let msg

  /**
   * @type {Boolean} - whether to show publish otp model or not
   */
  let showOTPModal = false

  /**
   * @type {String} - this variable store the user entered OPT
   */
  let code = ""

  /**
   * @type {String} - this variable store the document signature for publish
   */
  let signature = ""

  /**
   * @typedef {Object} closeNotification
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {closeNotification}
   */
  let closeNotification = {
    close() {},
  }

  /**
   * @description function for publish the document
   */
  const publish = async () => {
    msg = "Document publishing"
    showLoading = true
    let PublishDocIntervel
    let sampleObj = {
      documentID: $BadgePublish.documentId,
      signature: signature,
    }
    try {
      let data = await publishDocument($BadgePublish.documentId, sampleObj)

      showOTPModal = false
      if (data.state == "QUEUED") {
        PublishDocIntervel = setInterval(() => {
          clearInterval(PublishDocIntervel)
          publish()
        }, 5000)
        // publishNotify = notify.success("Your Document is <strong>QUEUED</strong>")
      }
      if (data.state == "PUBLISHED") {
        clearInterval(PublishDocIntervel)
        showLoading = false
        closeNotification = notify.success("Document <strong>PUBLISHED</strong> successfully")
        $BadgePublish.proposedURL = data.url
        push(`/documents/badge/details?documentId=${query.documentId}&badgeId=${query.badgeId}`)
        // push(`/publish/badge/final?documentId=${query.documentId}&badgeId=${query.badgeId}`)
        // console.log($BadgePublish)

        updateBadgePublish($BadgePublish)
        return
      }
    } catch (error) {
      // console.error(error)
      code = ""
      const info = "PAGE: Badge Publish (Publish Document for badge)\nEVENT: During publish process"
      //throws error as danger notification
      notify.danger(error, info)
      showLoading = false
    }
  }

  /**
   * @description function for genarate signature for publishing
   */
  const getPublishSignature = async (e) => {
    try {
      let target = e.detail.target
      code = target[0].value + target[1].value + target[2].value + target[3].value + target[4].value + target[5].value

      let reqBody = {
        msg: $BadgePublish.fileHash + $BadgePublish.dataHash,
        otp: code,
      }

      signature = await fetchSignature(reqBody)

      publish()
    } catch (error) {
      const info = "PAGE: Badge Publish (Publish Document for badge)\nEVENT: During signature generation before publish"
      notify.danger(error, info)
    } finally {
      code = ""
    }
  }
</script>

<svelte:window
  on:visibilitychange={() => ($ApplicationState = getupdatedAppStateValue())}
  on:load={() => {
    push(`/publish/badge?documentId=${query.documentId}&badgeId=${query.badgeId}`)
  }}
/>

<svelte:head>
  <title>Publish Badge</title>
</svelte:head>

{#if showOTPModal}
  <div class="fixed inset-0 z-10 mt-0 flex flex-col items-center justify-center gap-3 overflow-hidden bg-[#000000cc] backdrop-blur-md">
    <div class="relative m-6 transform select-none rounded-md bg-white text-left transition-all dark:bg-bodyblack md:m-0 md:w-[700px]">
      {#if $ApplicationState.secret}
        <div class="flex w-full items-center justify-center rounded-md bg-white p-3 pb-0 text-black dark:bg-bodyblack md:px-6 md:pt-6">
          <h1 class="select-none text-xl font-bold text-black dark:text-white lg:text-2xl xl:text-2xl">Confirmation</h1>
        </div>

        <div class="px-3 py-3">
          <AuthInput
            bind:code
            on:submit={getPublishSignature}
            cancelBtn={true}
            on:click={() => {
              showOTPModal = false
            }}
            title="Please enter an <strong>Authentication Code</strong> from the linked Authenticator App to confirm the publication of the document."
          />
        </div>
      {:else}
        <div class="flex w-full items-center justify-center rounded-md bg-white p-3 pb-0 text-black dark:bg-bodyblack md:px-6 md:pt-6">
          <h1 class="select-none text-xl font-bold text-black dark:text-white lg:text-2xl xl:text-2xl">Information</h1>
        </div>

        <div class="px-3 py-3">
          <h1 class="mb-6 block w-full select-none text-center text-sm font-medium text-gray-200 mobile:text-base">
            To proceed with the publishing process, you must enable 2FA. Once enabled, you can return here by navigating to <strong>Documents > Pending Documents</strong>
            and clicking on
            <strong>"{$BadgePublish.options.title || "Untitled document"} for {$BadgePublish.metadata.receiver.name}".</strong>
          </h1>
          <div class="flex w-full justify-center">
            <a href="#/settings/integration/authenticator" target="_blank" class="mt-6 flex h-9 w-fit min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed lg:px-4">
              <i class="fa-solid fa-diamond-turn-right" />
              &nbsp;&nbsp;Goto 2F Authentication&nbsp;
            </a>
          </div>
        </div>
      {/if}
    </div>
  </div>
{/if}
<div class="relative min-h-screen w-full overflow-hidden bg-[#f7f7f7] dark:bg-bodyblack">
  <Navbar />
  <div class="px-6 pb-40 pt-6">
    <div class="relative mx-auto h-full w-full max-w-[920px] rounded-md bg-[#f7f7f7] dark:bg-bodyblack">
      <Header title="Publish Document for badge" bind:showLoading bind:msg />
      <div class="relative flex min-h-[530px] flex-col justify-between gap-6 rounded-md bg-white p-6 dark:bg-mdGray mobile:p-12">
        <div class="flex flex-col items-center justify-center gap-6 mobile:gap-3 sm:flex-row sm:items-start">
          <div class="flex w-full flex-col items-center gap-3 rounded-md mobile:w-1/2">
            <div class="rounded-md">
              <img src={$BadgePublish.uri} alt="publishing-badge" class="rounded-md border border-gray-800" />
            </div>
          </div>
          <div class="h-[570px] w-full overflow-auto pr-3 sm:w-1/2">
            {#if $BadgePublish.metadata}
              <h1 class="select-none pb-3 text-2xl font-bold text-black dark:text-white">Metadata</h1>
              {#each Object.keys($BadgePublish.metadata) as title}
                <div class="group rounded-md p-2 pl-6 hover:bg-[#38BDF8]/20">
                  <h3 class="my-3 mb-2 select-none text-lg text-blue-500">
                    <strong class=" capitalize">{title}</strong>
                    details
                  </h3>
                  {#each Object.entries($BadgePublish.metadata[title]) as [keys, values]}
                    <div class="mb-2 w-full select-none px-3">
                      <p class="font-semibold capitalize text-gray-800 dark:text-gray-500">{keys}</p>
                      <p class="truncate font-medium {keys == 'Issued for Domain' ? '' : 'capitalize'} text-gray-200">{values}</p>
                    </div>
                  {/each}
                </div>
              {/each}
            {/if}
            <h1 class="select-none py-3 text-2xl font-bold text-black dark:text-white">Options</h1>
            <div class="group rounded-md p-2 pl-6 pt-4 hover:bg-[#38BDF8]/20">
              {#if $BadgePublish.options}
                {#each Object.entries($BadgePublish.options) as [keys, values]}
                  <div class="mb-2 w-full select-none px-3">
                    <p class="font-semibold capitalize text-gray-800 dark:text-gray-500">{keys}</p>
                    <p class="truncate font-medium capitalize text-gray-200">{keys == "date" || keys == "expireOn" ? new Date(values).toDateString() : values}</p>
                  </div>
                {/each}
              {/if}
            </div>
          </div>
        </div>
        <div class="flex items-center justify-end">
          <button
            on:click={() => {
              showOTPModal = true
            }}
            type="button"
            class="flex h-9 min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed lg:px-4"
          >
            <i class="fa-solid fa-upload" />
            <span class="select-none md:block">&nbsp;&nbsp;Publish to BlockChain&nbsp;</span>
          </button>
        </div>
        {#if showLoading}
          <LoadingScreen {msg} />
        {/if}
      </div>
    </div>
  </div>
  <Footer />
</div>
